import { useTenant } from "@hooks";
import { InvoiceProvider, isBonlivaCareCostCenter, Tenant } from "@bonliva-crm/shared";

export function useInvoiceProvider(costCenterId: string) {
  const { tenant } = useTenant();

  if (tenant === Tenant.WCC) {
    return InvoiceProvider.WCC;
  }

  return isBonlivaCareCostCenter(costCenterId)
    ? InvoiceProvider.BonlivaCare
    : InvoiceProvider.Fortnox;
}
